import React from 'react';
import {Outlet} from "react-router-dom";
import {Container, Row, Col} from 'react-bootstrap';
import styled from "styled-components";
import StickyHeader from "../components/Extra/NavBar";
import {FooterLayout} from "./FooterLayout";

const StyledRow = styled(Row)`
        padding-left: 0;
        padding-right: 0;
    `;

const StyledContainer = styled(Container)`
        padding-left: 0;
        padding-right: 0;
    `;



export const StaticArticleLayout = () => {

    return (
        <>
            <StickyHeader />
            <StyledContainer fluid>
                <StyledRow>
                    <Col lg={12}>
                        <div className="page-body">
                            <Outlet />
                        </div>
                    </Col>
                </StyledRow>
            </StyledContainer>
            <FooterLayout />
        </>
    )
}
